import { render, staticRenderFns } from "./DownloadsList.vue?vue&type=template&id=73b38b5b&scoped=true&"
import script from "./DownloadsList.vue?vue&type=script&lang=js&"
export * from "./DownloadsList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadsList.vue?vue&type=style&index=0&id=73b38b5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b38b5b",
  null
  
)

export default component.exports